import { Control } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../../../ui/components/ui/form';
import { Input } from '../../../../ui/components/ui/input';
import { FIELD_LABEL_CLASS } from '../../constants/offer-checkout.constants';
import { OfferCheckoutFormValues } from '../offer-checkout-form/offer-checkout-form.schema';

const CustomerContactFields = ({ control }: { control: Control<OfferCheckoutFormValues> }) => (
  <div className="flex flex-col gap-3">
    <FormField
      control={control}
      name="phone"
      render={({ field }) => (
        <FormItem>
          <FormLabel className={FIELD_LABEL_CLASS}>Telefon</FormLabel>
          <FormControl>
            <Input {...field} type="tel" className="bg-white" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
    <FormField
      control={control}
      name="invoiceMail"
      render={({ field }) => (
        <FormItem>
          <FormLabel className={FIELD_LABEL_CLASS}>Rechnungs-E-Mail</FormLabel>
          <FormControl>
            <Input {...field} type="email" placeholder="E-Mail für Rechnungen" className="bg-white" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  </div>
);

export default CustomerContactFields;
